// @ts-nocheck
import { motion } from "framer-motion";

const TeamCardSkeleton = () => {
  return (
    <motion.div
      className="bg-gradient-to-b from-gray-800/60 to-gray-900/60 rounded-xl overflow-hidden border border-gray-700/50 shadow-lg"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {/* Banner Image Skeleton */}
      <div className="relative h-32 w-full overflow-hidden border-b border-gray-800/70">
        <div className="absolute inset-0 bg-gray-800 animate-pulse"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent"></div>
      </div>

      <div className="px-6 pb-6 -mt-10 relative">
        {/* Profile Picture Skeleton */}
        <div className="relative z-10 mb-5">
          <div className="h-25 w-25 rounded-full bg-gray-700 animate-pulse"></div>
        </div>

        {/* Team Info Skeleton */}
        <div className="flex flex-col">
          <div className="flex items-center justify-between mb-2">
            <div className="h-6 w-32 bg-gray-700 rounded-md animate-pulse"></div>
            <div className="h-5 w-16 bg-gray-700 rounded-md animate-pulse absolute top-2 right-2"></div>
          </div>

          {/* Description Skeleton */}
          <div className="h-4 w-full bg-gray-700 rounded-md animate-pulse mb-4"></div>

          {/* Team Members Count Skeleton */}
          <div className="mt-2">
            <div className="flex items-center gap-2 mb-2">
              <div className="h-4 w-4 bg-gray-700 rounded-md animate-pulse"></div>
              <div className="h-4 w-32 bg-gray-700 rounded-md animate-pulse"></div>
            </div>

            {/* Owner Skeleton */}
            <div className="flex items-center gap-2 mb-3">
              <div className="h-4 w-4 bg-gray-700 rounded-md animate-pulse"></div>
              <div className="h-4 w-40 bg-gray-700 rounded-md animate-pulse"></div>
            </div>

            {/* Team Members Avatars Skeleton */}
            <div className="mt-3">
              <div className="h-3 w-28 bg-gray-700 rounded-md animate-pulse mb-2"></div>
              <div className="flex -space-x-3">
                {[1, 2, 3].map((i) => (
                  <div
                    key={i}
                    className="w-10 h-10 rounded-full bg-gray-700 animate-pulse"
                    style={{ marginLeft: i > 0 ? "-12px" : "0" }}
                  ></div>
                ))}
                <div className="w-10 h-10 rounded-full bg-gray-700 animate-pulse ml-[-12px] flex items-center justify-center">
                  <div className="h-3 w-3 bg-gray-600 rounded-md animate-pulse"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Button Skeleton */}
          <div className="mt-4">
            <div className="h-10 w-full bg-gray-700 rounded-lg animate-pulse"></div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default TeamCardSkeleton;